import { Stack, Text } from '@mantine/core'
import { redactPropsWithClassName, toCurrencyString } from '@phoenix-web/utils/general'
import { CLEARED_TO_CLOSE, FINAL_APPROVED, getProductLabel, TransactionType } from '@phoenix-web/utils/journey'

export const VISIBLE_STEPS = [FINAL_APPROVED, CLEARED_TO_CLOSE]
export const CUSTOMER_VISIBLE_STEPS = [CLEARED_TO_CLOSE]

export default function BoxAvailableFunds({
  availableFunds,
  loanAmount,
  userIsPartner = true,
  transactionType = TransactionType.HSEA1,
}: {
  availableFunds: string
  loanAmount?: string
  userIsPartner?: boolean
  transactionType?: TransactionType
}) {
  const productLabel = getProductLabel(transactionType)
  return (
    <Stack
      gap="xl"
      style={{ borderRadius: 'var(--mantine-radius-sm)' }}
      bd="1px solid light-gray.6"
      w="100%"
      p="lg"
      pb="xl"
    >
      <Text fw={700} size="lg">
        Available Funds
      </Text>

      <Stack gap={0}>
        <Text {...redactPropsWithClassName} fz={'2em'} fw={700}>
          {toCurrencyString(Number(availableFunds), { minimumFractionDigits: 2, maximumFractionDigits: 2 })}*
        </Text>
        <Text>available for the purchase transaction.</Text>
      </Stack>

      {userIsPartner ? (
        <Text {...redactPropsWithClassName} fz="xs" lh="xs">
          If your client wishes to use additional funds from the{' '}
          {loanAmount ? toCurrencyString(Number(loanAmount)) : ''} {productLabel} for the down payment, closing costs,
          or debt payoff, contact the Knock Loan Officer.
        </Text>
      ) : (
        <Text {...redactPropsWithClassName} fz="xs" lh="xs">
          If you wish to use additional funds from the {loanAmount ? toCurrencyString(Number(loanAmount)) : ''}{' '}
          {productLabel} for the down payment, closing costs, or debt payoff, contact you Knock Loan Officer
          immediately.
        </Text>
      )}

      <Text fz="xs" lh="xs">
        Knock does not allow more than $10,000 cash back from both the bridge and purchase closings. We will adjust
        funds if Earnest Money Deposit (EMD), seller credits, or tax prorations result in excess.
      </Text>

      <Text fz="xs" lh="xs">
        *Please note that this amount may change based on the receipt of purchase lender documents, borrower documents,
        title report, and any pending payoffs.
      </Text>
    </Stack>
  )
}
